import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"
import _imports_0 from '../../assets/img/icons/long-arrow.svg'


const _hoisted_1 = {
  id: "blog-area",
  class: "container pb-70 mn-section"
}
const _hoisted_2 = { class: "row justify-content-center" }
const _hoisted_3 = ["data-aos-delay"]
const _hoisted_4 = { class: "home_three-blog-card mb-30" }
const _hoisted_5 = { class: "blog-img overflow-hidden" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "blog-info" }
const _hoisted_8 = { class: "fs-26 lh-36" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "row" }, [
      _createElementVNode("div", {
        class: "col-lg-6 offset-lg-3",
        "data-aos": "fade-up",
        "data-aos-duration": "1000",
        "data-aos-delay": "100"
      }, [
        _createElementVNode("h2", { class: "fs-52 mb-40 text-center" }, " Update With Our Latest Blog & News ")
      ])
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.blogs, (blog) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "col-xl-4 col-md-6",
          key: blog.id,
          "data-aos": "fade-up",
          "data-aos-duration": "1000",
          "data-aos-delay": blog.dataDelay
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("img", {
                src: blog.image,
                alt: "Image",
                class: "transition"
              }, null, 8, _hoisted_6)
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("h3", _hoisted_8, [
                _createVNode(_component_router_link, { to: "/blog-details-left-sidebar" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(blog.title), 1)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _createElementVNode("p", null, _toDisplayString(blog.desc), 1),
              _createVNode(_component_router_link, {
                to: "/blog-details-left-sidebar",
                class: "link style-one"
              }, {
                default: _withCtx(() => _cache[0] || (_cache[0] = [
                  _createTextVNode(" Read More "),
                  _createElementVNode("img", {
                    src: _imports_0,
                    alt: "Image"
                  }, null, -1)
                ])),
                _: 1
              })
            ])
          ])
        ], 8, _hoisted_3))
      }), 128))
    ])
  ]))
}